import reducerRegistry from '../../../../helpers/ReducerRegistry';
import alertService from '../../../../../core/services/Tools/Alerts/AlertService';
import { formatData } from './../../../../helpers/Api';
import Const from './Const';

const { FUNDAMENTAL, EVENTS, TECHNICAL } = Const.NOTIFICATION_TYPES;

export const REDUCER_NAME = 'MAIN_LAYOUT:NOTIFI_ALERTS';
export const SUBSCRIBE_REALTIME_DATA_ALERT = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA_ALERT`;
export const SET_SYSTEM_ALERT = `${REDUCER_NAME}SET_ALERT_GROUP`;
export const SET_PERSONAL_ALERT = `${REDUCER_NAME}SET_PERSONAL_ALERT`;
export const REMOVE_PERSONAL_ALERT_SUCCESS = `${REDUCER_NAME}REMOVE_PERSONAL_ALERT_SUCCESS`;
export const FETCH_LIST_NOTIFICATION_SUCCESS = `${REDUCER_NAME}FETCH_LIST_NOTIFICATION_SUCCESS`;
export const SET_NOTIFICATION_LOADING = `${REDUCER_NAME}SET_NOTIFICATION_LOADING`;
export const SET_LOAD_MORE_NOTIFICATION = `${REDUCER_NAME}SET_LOAD_MORE_NOTIFICATION`;
export const UPDATE_NOTIFICATION_LIST = `${REDUCER_NAME}UPDATE_NOTIFICATION_LIST`;
export const ACTIVATE = 'Activate';
export const INACTIVATE = 'Inactivate';

const initialState = {
  personalAlerts: [],
  personalAlertsById: {},
  personalAlertIds: [],
  isPersonalAlertLoading: true,

  systemAlerts: [],
  systemAlertById: {},
  systemAlertIds: [],
  isSystemAlertLoading: true,

  notification: {},
  notificationLimit: {},
  isNotificationLoading: true,
};

const getChildrenIds = (systemAlerts, condition) => {
  const ids = [];
  systemAlerts.forEach(alert => {
    if (condition(alert)) {
      ids.push(alert.alertCode);
    }
  });

  return ids;
};

const getSystemAlertData = systemAlerts => {
  const systemAlertById = {};
  const systemAlertIds = [];
  systemAlerts.forEach(item => {
    systemAlertById[item.alertCode] = item;
    if (!systemAlertById[item.alertGroupCode]) {
      systemAlertById[item.alertGroupCode] = {
        isGroup: true,
        subscribed: item.groupSubscribed,
        code: item.alertGroupCode,
        name: item.alertGroupName,
        children: getChildrenIds(
          systemAlerts,
          alert => alert.alertGroupCode === item.alertGroupCode,
        ),
      };
    }
    systemAlertIds.push(item.alertCode);
  });
  return {
    systemAlertById,
    systemAlertIds,
    systemAlerts,
  };
};

const getPersonalAlertData = (alerts, field) => {
  const alertById = {};
  const alertIds = [];

  alerts.forEach(item => {
    alertById[item[field]] = item;
    alertIds.push(item[field]);
  });

  return [alertById, alertIds, alerts];
};

const formatPersonalAlert = items => {
  if (Array.isArray(items)) {
    return items.map(item => ({
      ...item,
      isActive: item.status === ACTIVATE,
    }));
  }

  return [];
};
export const fetchAllNotification = params => dispatch => {
  dispatch(setNotificationLoading(true));
  const promises = Object.values(Const.NOTIFICATION_TYPES).map(type => {
    return alertService.getNotificationList({
      ...params,
      AlertType: type,
    });
  });

  Promise.all(promises).then(([fundamental, events, technical]) => {
    const notificationLimit = {
      [FUNDAMENTAL]: fundamental.totalCount,
      [EVENTS]: events.totalCount,
      [TECHNICAL]: technical.totalCount,
    };
    const notification = {
      [FUNDAMENTAL]: fundamental.items,
      [EVENTS]: events.items || [],
      [TECHNICAL]: technical.items,
    };
    dispatch({
      type: FETCH_LIST_NOTIFICATION_SUCCESS,
      payload: {
        notification,
        notificationLimit,
      },
    });
  });
};

export const loadMoreNotification = params => dispatch => {
  dispatch(setNotificationLoading(true));
  alertService.getNotificationList(params).then(res => {
    dispatch({
      type: SET_LOAD_MORE_NOTIFICATION,
      payload: {
        alertType: params.AlertType,
        items: res.items,
      },
    });
  });
};

export const updateNotificationList = notification => ({
  type: UPDATE_NOTIFICATION_LIST,
  payload: notification,
});

export const setNotificationLoading = bool => ({
  type: SET_NOTIFICATION_LOADING,
  payload: bool,
});

export const fetchPersonalAlert = () => dispatch => {
  alertService.getPersonalSubsribedAlerts().then(res => {
    const [
      personalAlertById,
      personalAlertIds,
      personalAlerts,
    ] = getPersonalAlertData(formatPersonalAlert(res.items), 'personalAlertId');
    dispatch({
      type: SET_PERSONAL_ALERT,
      payload: {
        personalAlertById,
        personalAlertIds,
        personalAlerts,
      },
    });
  });
};

export const addPersonalAlert = params => dispatch => {
  return new Promise(resolve => {
    alertService.addPersonalAlert(params).then(response => {
      resolve(response.data.errors);
    });
  });
};

export const editPersonalAlert = params => dispatch => {
  return new Promise(resolve => {
    alertService.editPersonalAlert(params).then(response => {
      resolve(response.data.errors);
    });
  });
};

export const changeActivePersonalAlert = data => (dispatch, getState) => {
  const oldPersonalAlerts = getState()[REDUCER_NAME].personalAlerts;
  alertService.activePersonalAlert(data).then(res => {
    if (res.data.errors) {
      return;
    }
    const newPersonalAlerts = oldPersonalAlerts.map(item => {
      if (item.personalAlertId !== data.personalAlertId) {
        return item;
      }

      return {
        ...item,
        status: data.status,
        isActive: data.status === ACTIVATE,
      };
    });

    const [
      personalAlertById,
      personalAlertIds,
      personalAlerts,
    ] = getPersonalAlertData(newPersonalAlerts, 'personalAlertId');

    dispatch({
      type: SET_PERSONAL_ALERT,
      payload: {
        personalAlertById,
        personalAlertIds,
        personalAlerts,
      },
    });
  });
};

export const removePersonalAlert = id => dispatch => {
  const params = {
    alertId: id,
  };
  alertService.removePersonalAlert(params).then(() => {
    dispatch({
      type: REMOVE_PERSONAL_ALERT_SUCCESS,
      payload: id,
    });
  });
};

export const setSystemAlerts = items => {
  const { systemAlertById, systemAlertIds, systemAlerts } = getSystemAlertData(
    items,
  );
  return {
    type: SET_SYSTEM_ALERT,
    payload: {
      systemAlertById,
      systemAlertIds,
      systemAlerts,
    },
  };
};

export const fetchSystemAlert = params => {
  return dispatch => {
    alertService.getAllSystemAlerts(params).then(response => {
      dispatch(setSystemAlerts(formatData(response)));
    });
  };
};

export const subscribeRealtimeData = data => {
  return {
    type: SUBSCRIBE_REALTIME_DATA_ALERT,
    payload: {
      data,
    },
  };
};

export const subscribeSystemAlert = params => (dispatch, getState) => {
  alertService.subscribeSystemAlert(params).then(res => {
    if (res.data.errors) {
      return;
    }
    const newSystemAlerts = getState()[REDUCER_NAME].systemAlerts.map(item => {
      if (item.alertCode !== params.code) {
        return item;
      }

      return {
        ...item,
        subscribed: params.subscribe,
      };
    });

    dispatch(setSystemAlerts(newSystemAlerts));
  });
};

const removeDuplicate = notifications => {
  const uniqueNotifications = [];
  notifications.forEach(notification => {
    const isExist = uniqueNotifications.some(
      item => item.notificationId === notification.notificationId,
    );
    if (isExist) {
      return;
    }
    uniqueNotifications.push(notification);
  });

  return uniqueNotifications;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SYSTEM_ALERT: {
      const { systemAlertById, systemAlertIds, systemAlerts } = action.payload;
      return {
        ...state,
        systemAlertById,
        systemAlertIds,
        systemAlerts,
        isSystemAlertLoading: false,
      };
    }
    case SET_PERSONAL_ALERT:
      const {
        personalAlerts,
        personalAlertIds,
        personalAlertById,
      } = action.payload;

      return {
        ...state,
        personalAlerts,
        personalAlertIds,
        personalAlertById,
        isPersonalAlertLoading: false,
      };

    case REMOVE_PERSONAL_ALERT_SUCCESS:
      return {
        ...state,
        personalAlertIds: state.personalAlertIds.filter(
          id => id !== action.payload,
        ),
        personalAlerts: state.personalAlerts.filter(
          item => item.personalAlertId !== action.payload,
        ),
      };
    case SET_NOTIFICATION_LOADING:
      return {
        ...state,
        isNotificationLoading: action.payload,
      };
    case FETCH_LIST_NOTIFICATION_SUCCESS:
      return {
        ...state,
        notification: action.payload.notification,
        notificationLimit: action.payload.notificationLimit,
        isNotificationLoading: false,
      };
    case SET_LOAD_MORE_NOTIFICATION:
      const { items, alertType } = action.payload;
      return {
        ...state,
        notification: {
          ...state.notification,
          [alertType]: removeDuplicate([
            ...state.notification[alertType],
            ...items,
          ]),
        },
        isNotificationLoading: false,
      };
    case UPDATE_NOTIFICATION_LIST:
      const type = action.payload.alertType;
      return {
        ...state,
        notification: {
          ...state.notification,
          [type]: [action.payload, ...(state.notification[type] || [])],
        },
      };
    default:
      return state;
  }
};

reducerRegistry.register(REDUCER_NAME, reducer);
